import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ num, id, title, children }) => (
  <div id={id} style={{ marginBottom: 48 }}>
    <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize: 24, fontWeight: 700, color: '#1A1A2E', marginBottom: 16, paddingBottom: 12, borderBottom: '2px solid rgba(26,60,143,0.08)', display: 'flex', alignItems: 'center', gap: 10 }}>
      <span style={{ width: 32, height: 32, background: 'linear-gradient(135deg,#1A3C8F,#2451b3)', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: '#fff', flexShrink: 0 }}>{num}</span>
      {title}
    </h2>
    {children}
  </div>
);
const HBox = ({ children }) => (
  <div style={{ background:'rgba(26,60,143,0.04)',border:'1px solid rgba(26,60,143,0.12)',borderLeft:'4px solid #1A3C8F',borderRadius:'0 12px 12px 0',padding:'18px 22px',margin:'16px 0' }}>
    <p style={{ margin:0,color:'#444',fontSize:14 }}>{children}</p>
  </div>
);
const P = ({ children }) => <p style={{ color:'#555',fontSize:15,marginBottom:12 }}>{children}</p>;
const Li = ({ children }) => <li style={{ color:'#555',fontSize:15,marginBottom:8 }}>{children}</li>;

export default function Privacy() {
  const toc = [
    ['p1','Information We Collect'],
    ['p2','How We Use Your Data'],
    ['p3','Payment Information'],
    ['p4','Cookies'],
    ['p5','Your Rights'],
    ['p6','Changes to Policy']
  ];
  const tableRows = [
    ['Full name, Father/Mother name','Account identification'],
    ['Date of birth','Age verification'],
    ['Address','User profile'],
    ['Email address','Login, notifications, OTP'],
    ['Phone number','Login, support contact'],
    ['Exam group, Category, Gender','Personalise content'],
    ['UTR ID (payment reference)','Payment verification only']
  ];
  return (
    <div style={{ fontFamily:"'Sora',sans-serif",background:'#F8F9FF',minHeight:'100vh' }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700&family=Playfair+Display:wght@700;900&display=swap'); ::-webkit-scrollbar{width:6px} ::-webkit-scrollbar-thumb{background:#1A3C8F;border-radius:10px}`}</style>

      {/* Navbar */}
      <nav style={{ position:'fixed',top:0,left:0,right:0,zIndex:100,height:68,padding:'0 5%',display:'flex',alignItems:'center',justifyContent:'space-between',background:'rgba(248,249,255,0.92)',backdropFilter:'blur(20px)',borderBottom:'1px solid rgba(26,60,143,0.1)' }}>
        <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none' }}>
          <div style={{ width:38,height:38,background:'linear-gradient(135deg,#1A3C8F,#2451b3)',borderRadius:10,display:'flex',alignItems:'center',justifyContent:'center',fontSize:17 }}>🏆</div>
          <span style={{ fontFamily:"'Playfair Display',serif",fontSize:21,fontWeight:700,color:'#1A3C8F' }}>TNPSC <em style={{ color:'#F5A623',fontStyle:'normal' }}>Hub</em></span>
        </Link>
        <Link to="/" style={{ padding:'8px 20px',background:'linear-gradient(135deg,#F5A623,#e8940f)',borderRadius:8,color:'#102766',fontSize:13,fontWeight:700,textDecoration:'none' }}>← Back to Home</Link>
      </nav>

      {/* Hero */}
      <div style={{ background:'linear-gradient(135deg,#0d1f5c,#1A3C8F)',padding:'120px 5% 60px',textAlign:'center',position:'relative',overflow:'hidden' }}>
        <div style={{ position:'absolute',width:500,height:500,background:'radial-gradient(circle,rgba(245,166,35,0.12),transparent 70%)',top:-100,left:-50,pointerEvents:'none' }}/>
        <div style={{ display:'inline-flex',alignItems:'center',gap:8,background:'rgba(245,166,35,0.15)',border:'1px solid rgba(245,166,35,0.4)',borderRadius:50,padding:'6px 18px',color:'#F5A623',fontSize:12,fontWeight:700,letterSpacing:'1.5px',textTransform:'uppercase',marginBottom:20 }}>🔒 Privacy</div>
        <h1 style={{ fontFamily:"'Playfair Display',serif",fontSize:'clamp(32px,5vw,52px)',fontWeight:900,color:'#fff',marginBottom:16 }}>Privacy Policy</h1>
        <p style={{ color:'rgba(255,255,255,0.6)',fontSize:15,maxWidth:500,margin:'0 auto' }}>Your privacy matters to us. This policy explains how we collect, use, and protect your personal data.</p>
        <span style={{ marginTop:16,display:'inline-block',background:'rgba(255,255,255,0.08)',border:'1px solid rgba(255,255,255,0.15)',borderRadius:8,padding:'6px 16px',color:'rgba(255,255,255,0.5)',fontSize:12 }}>Last updated: March 2026</span>
      </div>
      <div style={{ lineHeight:0,background:'linear-gradient(135deg,#0d1f5c,#1A3C8F)' }}><svg viewBox="0 0 1440 40" fill="none" style={{ display:'block',width:'100%' }}><path d="M0,20 C360,40 1080,0 1440,20 L1440,40 L0,40 Z" fill="#F8F9FF"/></svg></div>

      <div style={{ maxWidth:860,margin:'0 auto',padding:'60px 5% 100px' }}>

        {/* TOC */}
        <div style={{ background:'#fff',borderRadius:16,padding:'28px 32px',border:'1px solid rgba(26,60,143,0.1)',marginBottom:48,boxShadow:'0 4px 20px rgba(26,60,143,0.06)' }}>
          <h3 style={{ fontSize:14,fontWeight:700,color:'#1A3C8F',textTransform:'uppercase',letterSpacing:1,marginBottom:16 }}>📑 Table of Contents</h3>
          <ol style={{ paddingLeft:20,display:'grid',gridTemplateColumns:'1fr 1fr',gap:'6px 24px' }}>
            {toc.map(([id,label])=>(
              <li key={id}><a href={`#${id}`} style={{ color:'#555',fontSize:13,textDecoration:'none' }}>{label}</a></li>
            ))}
          </ol>
        </div>

        <Section num="1" id="p1" title="Information We Collect">
          <P>When you register on TNPSC Hub, we collect the following personal information:</P>
          <table style={{ width:'100%',borderCollapse:'collapse',margin:'16px 0',borderRadius:12,overflow:'hidden',boxShadow:'0 2px 12px rgba(26,60,143,0.08)' }}>
            <thead><tr>{['Data Type','Purpose'].map(h=><th key={h} style={{ background:'#1A3C8F',color:'#fff',padding:'12px 16px',fontSize:13,fontWeight:600,textAlign:'left' }}>{h}</th>)}</tr></thead>
            <tbody>{tableRows.map(([d,p])=>(
              <tr key={d}>
                <td style={{ padding:'12px 16px',fontSize:13,color:'#555',borderBottom:'1px solid rgba(26,60,143,0.06)',background:'#fff' }}>{d}</td>
                <td style={{ padding:'12px 16px',fontSize:13,color:'#555',borderBottom:'1px solid rgba(26,60,143,0.06)',background:'#fff' }}>{p}</td>
              </tr>
            ))}</tbody>
          </table>
          <P>We also collect usage data such as test scores, answers, and login timestamps to provide analytics.</P>
        </Section>

        <Section num="2" id="p2" title="How We Use Your Data">
          <ul style={{ paddingLeft:20,marginBottom:12 }}>{[
            'Creating and managing your account',
            'Verifying payment and activating your account',
            'Sending account status notifications via email',
            'Providing personalised test content based on your exam group',
            'Generating performance analytics for your dashboard',
            'Sending password reset OTPs when requested'
          ].map(i=><Li key={i}>{i}</Li>)}</ul>
          <HBox>🔒 We <strong>never sell, rent, or trade</strong> your personal data to any third party for marketing or commercial purposes.</HBox>
        </Section>

        <Section num="3" id="p3" title="Payment Information">
          <P>TNPSC Hub does not store any banking or card details. Payments are made directly via UPI. We only store:</P>
          <ul style={{ paddingLeft:20,marginBottom:12 }}>{[
            'Your UTR (transaction reference) ID — for verification purposes only',
            'Payment status (pending / approved / rejected)',
            'Payment date and amount'
          ].map(i=><Li key={i}>{i}</Li>)}</ul>
          <P>We do not have access to your bank account, UPI PIN, or any payment credentials.</P>
        </Section>

        <Section num="4" id="p4" title="Cookies & Local Storage">
          <P>TNPSC Hub uses browser local storage to store your login session token (JWT). This is essential for maintaining your logged-in state across page visits.</P>
          <P>We do not use tracking cookies, advertising cookies, or third-party analytics cookies.</P>
        </Section>

        <Section num="5" id="p5" title="Your Rights">
          <ul style={{ paddingLeft:20,marginBottom:12 }}>{[
            'Access the personal data we hold about you',
            'Request correction of inaccurate data via your profile settings',
            'Request deletion of your account and associated data',
            'Opt out of non-essential email communications'
          ].map(i=><Li key={i}>{i}</Li>)}</ul>
          <P>To exercise any of these rights, contact us at <strong>support@tnpschub.msdiscoveries.com</strong>. We will respond within 7 working days.</P>
        </Section>

        <Section num="6" id="p6" title="Changes to This Policy">
          <P>We may update this Privacy Policy periodically. Any significant changes will be communicated via email to registered users. Continued use of the platform constitutes acceptance of the updated policy.</P>
        </Section>

        {/* Contact card */}
        <div style={{ background:'linear-gradient(135deg,#102766,#1A3C8F)',borderRadius:20,padding:36,textAlign:'center',marginTop:48 }}>
          <h3 style={{ fontFamily:"'Playfair Display',serif",fontSize:24,fontWeight:700,color:'#fff',marginBottom:12 }}>Privacy Concerns?</h3>
          <p style={{ color:'rgba(255,255,255,0.7)',fontSize:14,marginBottom:8 }}>Reach out to us and we'll address your concerns promptly.</p>
          <p style={{ color:'rgba(255,255,255,0.7)',fontSize:14 }}>
            📧 <a href="mailto:support@tnpschub.msdiscoveries.com" style={{ color:'#F5A623',fontWeight:600,textDecoration:'none' }}>support@tnpschub.msdiscoveries.com</a>
            &nbsp;|&nbsp;
            📞 <a href="tel:9443724724" style={{ color:'#F5A623',fontWeight:600,textDecoration:'none' }}>9443724724</a>
          </p>
        </div>

      </div>
      <footer style={{ background:'#1A1A2E',padding:'24px 5%',textAlign:'center' }}>
        <p style={{ color:'rgba(255,255,255,0.35)',fontSize:12 }}>© 2026 TNPSC Hub — msdiscoveries.com. All rights reserved.</p>
      </footer>
    </div>
  );
}
